// extracted by mini-css-extract-plugin
module.exports = {"textLink":"textLinkRenderer_textLink__26PtG"};